import { LencoTypography } from '@/atomic-components/LencoTypography';
import { getColor } from '@/utils/theme/colors';
import { Box } from '@mui/material';

const LAST_FEW_CUTTOFF_COUNT = 6;

export const AvailableStockCountLabel = (props: { count: number }) => {
	const getDisplayLabel = () => {
		let count = props.count > 0 ? props.count : 0;

		if (count == 0) {
			return '0 left';
		} else if (count < LAST_FEW_CUTTOFF_COUNT) {
			return `Last ${props.count} left`;
		} else {
			return `Only ${props.count} left`;
		}
	};
	return (
		<Box
			sx={{
				background:
					props.count < LAST_FEW_CUTTOFF_COUNT
						? getColor('Danger -1')
						: getColor('Warning 0'),
				p: '4px 8px',
				borderRadius: '4px',
				zIndex: 2,
			}}
		>
			<LencoTypography
				textAlign={'center'}
				variant='Small_Regular'
				color={'white'}
			>
				{getDisplayLabel()}
			</LencoTypography>
		</Box>
	);
};
